<script lang="ts">
  import { educations } from './data';
</script>

<section class="mt-2 md:mt-0 print:mt-0 print:mb-2">
  <h2 class="text-2xl uppercase print:text-lg print:mb-1">Education</h2>
  <hr />
  <ul>
    {#each educations as education}
      <li class="mb-3 md:mb-0 print:mb-1">
        <div class="flex justify-between">
          <h4 class="text-base md:text-xl font-bold print:text-sm">
            {education.school}
          </h4>
          <h4 class="text-base md:text-xl font-bold print:text-sm">
            {education.location}
          </h4>
        </div>
        <div class="flex justify-between">
          <h4 class="text-xs md:text-base print:text-xs">{education.degree}</h4>
          <h4 class="text-xs md:text-base print:text-xs">
            {education.graduated}
          </h4>
        </div>
      </li>
    {/each}
  </ul>
</section>
